module.exports = __webpack_public_path__ + "img/noto-sans-jp-v25-latin-regular.445ea6b.svg";